import * as React from 'react';
import { Grid, Typography } from '@mui/material';

const NoCustomerSelectedView: React.FC = () => {
    return (
        <Grid container direction={'column'} alignContent={'center'} justifyContent={'center'}>
            <Typography variant={'h6'}>Wählen Sie einen Kontakt aus, um eine Beratung zu starten</Typography>
        </Grid>
    );
};

export default NoCustomerSelectedView;
